import { render, staticRenderFns } from "./updateGovernmentMemberRole.vue?vue&type=template&id=0e2ba05f&scoped=true&"
import script from "./updateGovernmentMemberRole.vue?vue&type=script&lang=js&"
export * from "./updateGovernmentMemberRole.vue?vue&type=script&lang=js&"
import style0 from "./updateGovernmentMemberRole.vue?vue&type=style&index=0&id=0e2ba05f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2ba05f",
  null
  
)

export default component.exports